import { Actions } from "../constants/actionTypes";
import { takeLatest, takeEvery, call, put } from "redux-saga/effects";
import {
  fetchAllUsers,
  fetchUserDetails,
  getOrgInvitationsForUser,
  updateOrgUsersInvitation,
  apiFetchUsersNotifications,
  apiMarkNotificationRead,
  apiUpdateDetails,
  apiUsers,
  apiCheckUserPlan,
  apiIsUserPartOfOrg,
  apiGetThemeDetails,
} from "../Services/users/userApis";

export function* getAllUsersSaga() {
  yield takeLatest(Actions.API_ALL_USERS, fetchAllUsers);
}

export function* getUserDetails() {
  yield takeLatest(Actions.API_USER_DETAILS, fetchUserDetails);
}

export function* getOrgInvitationsForUserSaga() {
  yield takeLatest(Actions.API_ORG_USER_INVITATIONS, getOrgInvitationsForUser);
}

export function* updateOrgUserInvitationSaga() {
  yield takeEvery(
    Actions.API_UPDATE_ORG_USER_INVITATION,
    updateOrgUserInvitationAction
  );
}

function* updateOrgUserInvitationAction(action) {
  const result = yield call(
    updateOrgUsersInvitation,
    action.invitation,
    action.status
  );
  if (result.isApiSuccessful) {
    yield put({
      type: Actions.API_ORG_DASHBOARD,
    });
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* usersApi() {
  yield takeLatest(Actions.API_USERS, usersSetApi);
}

function* usersSetApi(action) {
  const result = yield call(apiUsers, action);
}

export function* userNotifications() {
  yield takeLatest(
    [Actions.API_GET_USER_NOTIFICATIONS],
    fetchUsersNotifications
  );
}

export function* fetchUsersNotifications(action) {
  const { page } = action;
  const pageNumber = page !== undefined ? page : 0;
  const result = yield call(apiFetchUsersNotifications, pageNumber);
  if (result.isApiSuccessful) {
    const newData = {
      newNotifications: result.data.newNotifications,
      oldNotifications: result.data.oldNotifications,
      oldNotificationsCount: result.data.oldNotificationsCount,
      newNotificationsCount: result.data.newNotificationsCount,
    };
    yield put({
      type: Actions.SET_USERS_NOTIFICATIONS,
      data: result.data,
    });

    action.meta?.onSuccess(newData);
  } else {
    console.log("API FAILED: API_GET_USER_NOTIFICATIONS");

    action.meta?.onError();
  }
}

export function* markNotificationsRead() {
  yield takeLatest([Actions.API_MARK_NOTIFICATIONS_READ], markNotifications);
}

export function* markNotifications(action) {
  const { selectedNotificationBodies } = action.data;

  try {
    const result = yield call(
      apiMarkNotificationRead,
      selectedNotificationBodies
    );

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_USERS_NOTIFICATIONS,
        data: result.data,
      });
      action.meta?.onSuccess?.();

      yield call(fetchUsersNotifications);
    } else {
      console.log("API FAILED: API_MARK_NOTIFICATIONS_READ");
      action.meta?.onError?.();
    }
  } catch (error) {
    console.error("Error in markNotifications saga:", error);
    action.meta?.onError?.(error);
  }
}

export function* updateUserDetails() {
  yield takeLatest(Actions.API_UPDATE_USER_DETAILS, updateDetails);
}

function* updateDetails(action) {
  const result = yield call(apiUpdateDetails, action.userDetails);
  if (result.isApiSuccessful) {
    // Toast("Success!!", "Changes Updated", "success");
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
    // Toast(
    //   "Technical Issue",
    //   result?.data?.errorMessage || "Please try again later",
    //   "danger"
    // );
  }
}

export function* checkUserPlan() {
  yield takeLatest(Actions.API_CHECK_USER_HAS_PLAN, checkUserPlanSaga);
}

function* checkUserPlanSaga(action) {
  const result = yield call(apiCheckUserPlan, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* isUserPartOfOrg() {
  yield takeLatest(Actions.API_IS_USER_PART_OF_ORG, isUserPartOfOrgSaga);
}

function* isUserPartOfOrgSaga(action) {
  const result = yield call(apiIsUserPartOfOrg, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}

export function* apiGetTheme() {
  yield takeLatest(Actions.API_GET_THEME_DETAILS, apiTheme);
}

function* apiTheme(action) {
  const result = yield call(apiGetThemeDetails, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
}
